import { render } from "./confirm_modal.vue?vue&type=template&id=c74bcd96"
import script from "./confirm_modal.js?vue&type=script&lang=js"
export * from "./confirm_modal.js?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__